import useStyles from './style';
import axios from 'axios';
import { Paper, Grid, Avatar, Button, Typography, Container, IconButton } from '@material-ui/core';
import Icon from './Icon';
import React from 'react';
// import Twitter from 'twitter-lite'
// import TwitterLogin from "react-twitter-login";
// import MicrosoftLogin from "react-microsoft-login";
// import InstagramLogin from 'react-instagram-login';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import GitHubIcon from '@material-ui/icons/GitHub';
import GitHubLogin from 'react-github-login';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import LockOutline from '@material-ui/icons/LockOutlined';
import Input from './Input';
// import TwitterIcon from '@material-ui/icons/Twitter';
import { useEffect, useState } from 'react';
import { GoogleLogin } from 'react-google-login';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getusers, signin, signup } from '../../actions/auth';
import { toast } from 'react-toastify';
import { AUTH } from '../../constants/actionTypes';
import { validate } from 'email-validator';
import './style.css';
import emailjs from 'emailjs-com';
import ActionAlerts from '../AlertMessage';
import CustomTicker from './customTicker';
// import SocialLoginButton from './Social';

function Auth({ Sign, setSign,setFormdata, formData, errors, setErrors, switchMode, setLog }) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const handleSubmit = (e) => {
        e.preventDefault();
        if (Sign) {
            dispatch(signup(formData, history));
            setTimeout(() => {
                const users = JSON.parse(localStorage.getItem('users'))
                emailjs.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, { to_name: users?.result?.name, from_name: "Nandy" }, users?.result?.email)
                setLog(true);
            }, 1000);
        } else {
            dispatch(signin(formData, history));
            setTimeout(()=>{
                const users = JSON.parse(localStorage.getItem('users'))
                if(users?.result?.email){
                    setLog(true);
                    setSign(!Sign)
                }
            },1000)
        }


    };
    useEffect(() => {
        dispatch(getusers())
        // eslint-disable-next-line
    }, [])

    const handleChange = (e) => {
        switch (e.target.name) {
            case 'email':
                if (Sign) {
                    const users = JSON.parse(localStorage.getItem('users'))
                    let emails = [];
                    if (users) emails = users.map((item) => { return item.email })
                    if (emails.indexOf(e.target.value) !== -1) {
                        setErrors({ ...errors, email: { bool: true, text: 'User Already Exists!!' } })
                    }
                    else if (!validate(e.target.value)) {
                        setErrors({ ...errors, email: { bool: true, text: 'Provide a valid Email Address !!' } })
                    }
                    else {
                        setErrors({ ...errors, email: { bool: false, text: '' } })
                    }
                } else {
                    if (!validate(e.target.value)) {
                        setErrors({ ...errors, email: { bool: true, text: 'Provide a valid Email Address !!' } })
                    }
                    else {
                        setErrors({ ...errors, email: { bool: false, text: '' } })
                    }
                }
                break;
            case 'firstName':
                if (e.target.value.length <= 3) {
                    setErrors({ ...errors, firstName: { bool: true, text: 'Name should be > than 3 characters!!' } })
                } else {
                    setErrors({ ...errors, firstName: { bool: false, text: '' } })
                }
                break;
            case 'password':
                if (Sign) {
                    let messages = [];
                    if (e.target.value.length < 7) {
                        messages.push('Password should be > than 6 characters!!')
                    }
                    if (!/[A-Z]/.test(e.target.value)) {
                        messages.push('Password should contain atleast 1 Uppercase character!')
                    }
                    if (!/[!@#$&*^%~+=]/.test(e.target.value)) {
                        messages.push('Password should contain atleast 1 Special character!')
                    }
                    if (messages.length !== 0) {
                        setErrors({ ...errors, password: { bool: true, text: messages } })
                    } else {
                        setErrors({ ...errors, password: { bool: false, text: [] } })
                    }
                }
                break;
            case 'confirmpass':
                let pass = formData.password
                if (pass !== e.target.value) {
                    setErrors({ ...errors, confirmpass: { bool: true, text: 'Passwords doesn\'t match !' } })
                } else {
                    setErrors({ ...errors, confirmpass: { bool: false, text: '' } })
                }
                break
            default:
                break;
        }
        setFormdata({ ...formData, [e.target.name]: e.target.value })
    }
    const handleShowpassword = () => {
        setShowPass(!showPass);
    };


    const [showPass, setShowPass] = useState(false);
    const history = useHistory();

    const googleSuccess = async (res) => {
        const result = res?.profileObj;
        const token = res?.tokenId;
        try {
            dispatch({ type: AUTH, data: { result, token } })
            setLog(false);
            history.push('/');
            toast.success(`Welcome user ${result.name} :)`)
        } catch (error) {
            console.log(error);
        }
    };
    const fblogin = (res) => {
        const result = res;
        const token = res?.signedRequest
        console.log(res)
        try {
            dispatch({ type: AUTH, data: { result, token } })
            setLog(false)
            history.push('/');
            toast.success(`Welcome user ${result.name} :)`)
        } catch (error) {
            console.log(error);
        }
    }
    // const [gcolor, setGcolor] = useState({ color: 'red', bgcolor: 'white' });
    const googleFailure = (err) => {
        toast.error('Google Login Failed! Try again later :(', 'success');
    };
    const getGithubaccesstoken = async (code) => {
        const response = await axios(`https://cors-anywhere.herokuapp.com/https://github.com/login/oauth/access_token?client_id=${process.env.REACT_APP_GITHUB_CLIENTID}&client_secret=${process.env.REACT_APP_GITHUB_SECRET}&code=${code}`, {
            headers: {
                'Accept': 'application/json',
            }
        })
        return response.data.access_token
    };
    const linkedInredirect = "https://mempro.netlify.app/linkedin"
    const githubSuccess = async (res) => {
        const token = await getGithubaccesstoken(res.code)
        const url = "https://api.github.com/user"
        const headers = { Authorization: `token ${token}` }
        const userData = await axios(url, { headers: headers })
        const result = userData.data;
        try {
            dispatch({ type: AUTH, data: { result, token, type: "github" } })
            setLog(false)
            history.push('/');
            toast.success(`Welcome user ${result.name} :)`)
        } catch (error) {
            console.log(error);
        }

    };
    const githubFailure = (err) => {
        toast.error("Github Login Failed  :( Try again later")
    };
    const linkedInsuccess = async (res) => {
        const response = await axios(`https://cors-anywhere.herokuapp.com/https://www.linkedin.com/oauth/v2/accessToken?grant_type=authorization_code&redirect_uri=${linkedInredirect}&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&client_secret=${process.env.REACT_APP_LINKEDIN_CLIENT_SECRET}&code=${res.code}`, {
            headers: { 'Content-Type': 'x-www-form-urlencoded' }
        })
        const token = response?.data?.access_token
        const expiry_time = response?.data?.expires_in
        const profile_data = await axios(`https://cors-anywhere.herokuapp.com/https://api.linkedin.com/v2/me?projection=(id,localizedFirstName,phoneNumbers,localizedLastName,profilePicture(displayImage~:playableStreams))`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        const result = profile_data.data
        let elem = result.profilePicture['displayImage~'].elements
        const imageUrl = elem[elem.length - 1].identifiers[0].identifier

        try {
            dispatch({ type: AUTH, data: { ...result, imageUrl, token, expiry_time, type: "linkedin" } })
            setLog(false)
            history.push('/');
            toast.success(`Welcome user ${result?.localizedFirstName} ${result?.localizedLastName}  :)`)
        } catch (error) {
            console.log(error);
        }
    };
    const linkedInfailure = (err) => {
        console.log(err)
        toast.error("Linkedin Login Failed  :( Try again later")
    };

    return (
        <Container component="main" maxWidth="xs">
            <CustomTicker message="Twitter Authentication will be available soon!!" />
            <ActionAlerts severity="info" message="LinkedIn Authentication is now Available! If there is any issue ping me via https://jjnanthakumar.github.io :)" />
            <Paper className={classes.paper} elevation={3}>
                <Avatar className={classes.avatar}>
                    <LockOutline />
                </Avatar>
                <Typography variant="h5">{Sign ? 'Sign Up' : 'Sign In'}</Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {Sign && (
                            <>
                                <Input helperText={errors.firstName.text} error={errors.firstName.bool} value={formData.firstName} name="firstName" label="First Name" autoFocus={Sign} half handleChange={handleChange} />
                                <Input value={formData.lastName} name="lastName" label="Last Name" half handleChange={handleChange} />
                            </>

                        )}
                        <Input helperText={errors.email.text} error={errors.email.bool} id="email_test" type="email" value={formData.email} name="email" label="Email Address" handleChange={handleChange} />
                        <Input helperText={errors.password.text} id="pass" error={errors.password.bool} value={formData.password} name="password" type={showPass ? "text" : "password"} handleShowpassword={handleShowpassword} label="Password" handleChange={handleChange} />
                        {Sign && (
                            <Input helperText={errors.confirmpass.text} error={errors.confirmpass.bool} value={formData.confirmpass} name="confirmpass" label="Confirm Password" type={showPass ? "text" : "password"} handleShowpassword={handleShowpassword} handleChange={handleChange} />
                        )}
                    </Grid>
                    <Button type="submit" className={classes.submit} fullWidth variant="contained" color="primary">
                        {Sign ? 'Sign Up' : 'Sign In'}
                    </Button>
                    <Typography style={{ padding: '5px' }} variant="h6" color="secondary" align="center">OR</Typography>
                    <Paper variant="outlined" style={{ padding: '10px' }}>
                        <Grid container justify="center" className="social">
                            <Grid item>
                                <GitHubLogin
                                    clientId={process.env.REACT_APP_GITHUB_CLIENTID}
                                    redirectUri=""
                                    className="githublogin"
                                    onSuccess={githubSuccess}
                                    onFailure={githubFailure}><IconButton id="github" className={classes.gitbtn}
                                        fullWidth>
                                        <GitHubIcon />
                                    </IconButton>
                                </GitHubLogin>
                            </Grid>
                            <Grid item>
                                <GoogleLogin
                                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                    render={(renderProps) => (
                                        <IconButton id="google" className={classes.googleButton}
                                            fullWidth color="secondary"
                                            onClick={renderProps.onClick}
                                            disabled={renderProps.disabled}

                                            variant="contained">
                                            <Icon />
                                        </IconButton>
                                    )}
                                    onSuccess={googleSuccess}
                                    onFailure={googleFailure}
                                    cookiePolicy="single_host_origin"
                                />
                            </Grid>
                            {/* <Grid item>
                                <TwitterLogin
                                    loginUrl="http://localhost:5000/auth/twitter"
                                    onFailure={twitterFailure}
                                    onSuccess={twitterSuccess}
                                    requestTokenUrl="http://localhost:5000/auth/twitter/callback"
                                ><IconButton><TwitterIcon /></IconButton></TwitterLogin>
                            </Grid> */}
                            <Grid item>
                                <FacebookLogin
                                    appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                                    fields="name,email,picture"
                                    callback={fblogin}
                                    render={renderProps => (
                                        <IconButton id="fb" className={classes.fbbtn} fullWidth color="primary" variant="contained" onClick={renderProps.onClick}><FacebookIcon /></IconButton>
                                    )}
                                />
                            </Grid>
                            <Grid item>
                                {/* <MicrosoftLogin clientId={"clientId"} authCallback={authHandler} buttonTheme="dark_short" /> */}
                                {/* <InstagramLogin
                                    clientId={process.env.REACT_APP_INSTA_APP_ID}
                                    buttonText="Login"
                                    redirectUri="https://mempro.netlify.app/"
                                    scope="user_profile,user_media"
                                    onSuccess={responseInstagram}
                                    onFailure={responseInstagram}
                                /> */}
                                {/* 
                                >
                                    <Button>Instagram</Button>
                                </SocialButton> */}
                                {/* <SocialLoginButton
                                    provider='amazon'
                                    appId={process.env.REACT_APP_AMAZON_APP_ID}
                                    callback={responseInstagram}
                                >
                                    Login
                                </SocialLoginButton> */}
                            </Grid>
                            <Grid item>
                                <LinkedIn
                                    clientId={process.env.REACT_APP_LINKEDIN_CLIENT_ID}
                                    scope="r_liteprofile"
                                    onFailure={linkedInfailure}
                                    onSuccess={linkedInsuccess}
                                    redirectUri="https://mempro.netlify.app/linkedin"
                                    renderElement={({ onClick, disabled }) => (
                                        <IconButton onClick={onClick} id="linkedin" className={classes.linkedinbtn} color="primary" fullWidth variant="contained" disabled={disabled}><LinkedInIcon /></IconButton>
                                    )}
                                />
                            </Grid>

                        </Grid>
                    </Paper>

                    <Grid container justify="flex-end">
                        <Grid item>
                            <Button style={{ textTransform: 'capitalize' }} onClick={switchMode}>
                                {Sign ? "Already Have an Account? Log in" : "Don't have an account? Sign Up"}</Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        </Container >

    )
}

export default Auth